import api from "../../BaseUrl";
import axios from "axios";

//  İletişim formu
export function questionAdd(data) {
  return api.post("/v1/ContactForm/Add", data);
}

// Kimlik tabanlı login (eğer backend'in identity sistemi kullanıyorsa)
export function userIdentityAction(data) {
  return api.post("/v1/User/Login", data);
}
// Şöyle olmalı:
export const getUsers = () => {
  return api.get("/auth/users");
};
// Normal login
export function login(data) {
  return api.post("/auth/login", data);
}

// Kayıt olma
export function register(data) {
  return api.post("/auth/register", data);
}

//  Kullanıcı bilgilerini getir (id ile)
export function getUpdatedUser(id) {
  return api.get(`/user/${id}`);
}

//  Logout işlemi
export function logout() {
  return api.post("/auth/logout"); // GET yerine POST daha güvenlidir
}

//  Genel sistem bilgileri (örneğin info endpoint)
export function getInfos() {
  return api.get("/info");
}

// Kullanıcı token'ını al (artık interceptor sayesinde opsiyonel)
export function getUserByToken() {
  return localStorage.getItem("@authToken") || localStorage.getItem("token");
}

export const resetPassword = (data) => {
  return api.post("/admin/reset-password", data);
};

export function getSystemSettings() {
  return api.get("/admin/settings");
}

export function updateSystemSettings(data) {
  return api.put("/admin/settings", data);
}
